import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';

type BarcodeIssuesLoadErrorProps = {
    /** `initial`: no list has been read; `refresh`: the shown list is the last one read. */
    kind: 'initial' | 'refresh';
    onRetry: () => void;
};

/**
 * A failed read of the list, with Retry (rulebook §12): in place of the table
 * when no list was ever read, or above the rows it keeps when a refresh
 * failed.
 */
export const BarcodeIssuesLoadError: React.FC<BarcodeIssuesLoadErrorProps> = ({
    kind,
    onRetry,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Alert
            status={kind === 'initial' ? 'danger' : 'warning'}
            {...getNodeTestIdProp(
                kind === 'initial'
                    ? 'barcode-issues-load-error'
                    : 'barcode-issues-refresh-error',
            )}
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>
                    {kind === 'initial'
                        ? t('products.barcodeIssues.loadError.title')
                        : t('products.barcodeIssues.loadError.refreshTitle')}
                </Alert.Title>
            </Alert.Content>
            <Button onPress={onRetry} size="sm" variant="secondary">
                {t('products.barcodeIssues.loadError.retry')}
            </Button>
        </Alert>
    );
};
